<template>
  <div>
    <div v-if="this.label" class="customInput__label">
      {{ label
      }}<span
        v-if="required"
        style="color: red;"
        >{{ required ? '*' : '' }}</span
      >
    </div>
    <q-input
      :disable="!!this.disable"
      :dense="true"
      :required="!!this.required"
      :rows="inputRows"
      ref="customInput"
      :min="allowNegative ? undefined : allowNegative === false ? 0 : (this.min !== undefined ? this.min : 0)"
      :max="this.max" step="any"
      :hide-bottom-space="this.hideBottomSpace === undefined || this.hideBottomSpace === true"
      :placeholder="this.placeholder || 'Введите..'"
      :class="['customInput', {customInput__autoMinWidth: !!this.autoMinWidth}]"
      :mask="inputMask"
      :type="this.inputType"
      :input-class="{customInput__hideControls: this.controls !== true, customInput__bold: this.bold}"
      v-model="model"
      :hint="this.hint"
      @clear="clearValue"
      @focus="e => this.$emit('focus', e)"
      @blur="e => this.$emit('blur', e)"
      :loading="this.loading"
      :rules="this.rules"
      outlined
      :suffix="this.suffix"
      @keyup.enter="this.$emit('enter')"
    >
      <template v-slot:default v-if="!!this.title">
        <q-tooltip>
          {{this.title}}
        </q-tooltip>
      </template>
      <template v-slot:append v-if="this.type === 'password'">
        <q-tooltip
          v-if="!!this.afterTextTitle"
          anchor="top left"
          self="top left"
          :offset="[20, 5]"
        >
          {{this.afterTextTitle}}
        </q-tooltip>
        <q-icon
          :name="isPwd ? 'visibility_off' : 'visibility'"
          class="cursor-pointer"
          @click="isPwd = !isPwd"
        />
      </template>
      <template
        v-if="value && this.type !== 'password' && this.showClearIcon !== false"
        v-slot:append
      >
        <span v-if="this.afterText !== undefined" class="afterText">
          {{ this.afterText }}
          <q-tooltip
            v-if="!!this.afterTextTitle"
            anchor="top left"
            self="top left"
            :offset="[20, 5]"
          >
            {{this.afterTextTitle}}
          </q-tooltip>
        </span>
        <q-icon
          name="cancel"
          @click.stop.prevent="clearValue"
          class="cursor-pointer customInput__icon"
        />
      </template>
      <template v-slot:append v-if="this.isSearch">
        <q-icon name="search" />
      </template>
      <template v-slot:append v-if="this.disable && this.showDisable">
        <q-icon name="block" />
      </template>
    </q-input>
  </div>
</template>

<script>
import {customInputRules} from "@/components/form/CustomInput/services";

export default {
  name: "CustomInput",
  props: ["value", "type", "label", "placeholder", "bold", "afterText", "afterTextTitle", "title", "autoMinWidth", "controls", "min", "max",
    "required", "triggerValidationOnMount", "loading", "isSearch", "onPressEnter", "disable", "showDisable", "integer", "suffix", "showClearIcon", "allowNegative", "hideBottomSpace", "hint", "rows"],
  data() {
    return {
      isPwd: this.type === 'password' || null,
    }
  },
  methods: {
    clearValue() {
      this.$emit("change_input", "");
      this.$emit("clear_input", "");
    },
  },
  mounted() {
    if (this.triggerValidationOnMount)
      this.$refs.customInput.validate()
  },
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(newValue) {
        let value = newValue
        if(this.allowNegative === false && Number(newValue) < 0) {
          value = 0
        }
        if (this.integer && !!value) {
          const intValue = parseInt(value, 10);
          const isCorrect = !isNaN(intValue) && intValue.toString() === value.toString()
          if (!isCorrect) value = parseInt(value, 10)
        }
        this.$emit("change_input", value);
      },
    },
    inputMask() {
      if (this.type === 'phone') return '+# (###) ### - ####'
    },
    inputType() {
      if (this.type === 'phone') return
      return this.isPwd ? 'password' : this.isPwd === null ? this.type || 'text' : 'text'
    },
    inputRows() {
      const n = Number(this.rows)
      if (Number.isFinite(n) && n > 0) return n
      return 2
    },
    rules() {
      return customInputRules({ required: this.required, max: this.max })
    },
  },
};
</script>

<style lang="scss">

.customInput {
  --ci-height: 40px;
  --ci-radius: 8px;

  min-width: 100px;
  min-height: var(--ci-height);
  padding-bottom: 0 !important;

  .q-field__control:before {
    border-radius: var(--ci-radius);
    border-color: #D1D5DB !important;
  }
  .q-field__control:after {
    border-radius: var(--ci-radius) !important;
  }

  &__autoMinWidth {
    min-width: unset;
  }

  &__icon {
    font-size: 19px;
  }

  &__bold {
    font-weight: 700 !important;
  }

  &__hideControls {
    /* Chrome, Safari, Edge, Opera */
    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
      -webkit-appearance: none !important;
      appearance: none !important;
      margin: 0 !important;
    }

    /* Firefox */
    &[type="number"] {
      -moz-appearance: textfield !important;
    }
  }

  & .q-field__bottom {
    padding-top: 4px !important;
    padding-left: 0 !important;
    font-size: 12px !important;
  }

  & .q-placeholder::placeholder {
    color: #9CA3AF;
    font-size: 12px;
  }
  &__label {
    font-size: 13px;
    line-height: 13px;
    margin-bottom: 8px;
  }
}

.afterText {
  height: 100%;
  font-size: 11px;
  display: flex;
  align-items: flex-end;
}
</style>
